import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC1Eiq4Mc5u1J8VNmj4E055QgZKSQRPBYI",
  authDomain: "cft-ra.firebaseapp.com",
  projectId: "cft-ra",
  storageBucket: "cft-ra.appspot.com",
  messagingSenderId: "351486344296",
  appId: "1:351486344296:web:24caabaff1ffc04c92cfdd",
  measurementId: "G-4J1QB6SQYD"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
